import React from 'react';
import { MdConfirmationNumber, MdIosShare, MdMail } from 'react-icons/md';

import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Divider from 'legacy/common/components/wysiwyg-form/Divider';
import { EventForUser } from '../../types';

type GuestEventOptionsProps = {
  event: EventForUser;
  onClickViewContactsModal: () => void;
  toggleCheckout: () => void;
  onClickViewShareOptions: () => void;
  toggleManageEvent: () => void;
  visible: boolean;
  isLoggedIn: boolean;
};

const GuestEventOptions: React.FC<GuestEventOptionsProps> = ({
  event,
  onClickViewContactsModal,
  toggleCheckout,
  onClickViewShareOptions,
  toggleManageEvent,
  visible,
  isLoggedIn
}) => {
  const onOptionClick = (action) => () => {
    toggleManageEvent();
    action();
  };

  return (
    <Modal
      type={ModalType.SMALL}
      onClose={toggleManageEvent}
      autoHeight
      hideCloseButton
      visible={visible}
    >
      <div className="p-4 flex flex-col gap-3">
        <Button
          type={ButtonType.Inverted}
          icon={<MdConfirmationNumber size={20} />}
          onClick={onOptionClick(toggleCheckout)}
          disabled={event.activeStatus === 'past'}
        >
          Get tickets
        </Button>
        {isLoggedIn && (
          <Button
            type={ButtonType.Inverted}
            icon={<MdMail size={20} />}
            onClick={onOptionClick(onClickViewContactsModal)}
            testId="button-contact-host"
          >
            Contact host
          </Button>
        )}
        {!(event.private && !event.isOrganizer) && (
          <>
            <Divider size={4} />
            <div className="flex flex-col mt-4">
              <Button
                type={ButtonType.Inverted}
                onClick={onOptionClick(onClickViewShareOptions)}
                icon={<MdIosShare size={20} />}
              >
                Share event
              </Button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default GuestEventOptions;
